import { createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrlApi } from "../../proxy";
import axios, { AxiosResponse } from "axios";

export const toGetBranches = createAsyncThunk<AxiosResponse<any, any>, any>(
  "branches/toGetBranches",
  async (lang) => {
    try {
      const response = await axios.get(
        `${baseUrlApi}portal/branches?lang=${lang}`
      );
      return response;
    } catch (error) {
      throw error;
    }
  }
);
